
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-check-newsletter',
    imports: [
    FormsModule
],
    templateUrl: './check-newsletter.component.html',
    styleUrls: ['./check-newsletter.component.scss']
})
export class CheckNewsletterComponent {
  @Input() public isChecked: boolean;
  @Output() public onChecked: EventEmitter<boolean>;

  public constructor() {
    this.isChecked = false;
    this.onChecked = new EventEmitter<boolean>();
  }

  public checkValue(e: Event): void {
    if (!e.target) {
      return;
    }
    let target = e.target as HTMLInputElement;
    let checked = target.checked;

    this.isChecked = checked;
    this.onChecked.emit(checked);
  }
}
